// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alert{z-index:99999;position:fixed;top:10px;margin:auto;left:50%;transform:translateX(-50%);width:400px;max-width:92%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
